import { render, staticRenderFns } from "./AdminBindings.vue?vue&type=template&id=e675b308&scoped=true"
import script from "./AdminBindings.vue?vue&type=script&lang=js"
export * from "./AdminBindings.vue?vue&type=script&lang=js"
import style0 from "./AdminBindings.vue?vue&type=style&index=0&id=e675b308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e675b308",
  null
  
)

export default component.exports